import type { MapRowValue } from '../../backend.d'
import { createResource, type Accessor } from 'solid-js'
import { parse } from 'valibot'
import { backendAxios } from '../../axios'
import { StateSchema } from '../../lib/core/state/State.type'
import type { StateOnlineId } from '../../lib/core/state/StateOnlineId.type'
import { Nullable } from '../../typescript'
import { mapDisk } from '../../lib/core/disk/IndexedDBDisk'
import { StateMapDisk } from '../../lib/core/state/state_map_disk.enum'
import { hasIndexedDB } from '../../lib/core/Storage/IndexedDB/hasIndexedDB'

async function fetchMapById(
  stateId: Nullable<StateOnlineId>,
  disk: StateMapDisk
): Promise<MapRowValue | null> {
  if (stateId) {
    // Use explicit disk parameter if provided
    const useIndexedDB = disk === StateMapDisk.IndexedDB
    const useCloud = disk === StateMapDisk.Cloud
    if (!useIndexedDB && !useCloud) {
      throw new Error('Invalid disk: ' + disk)
    }
    if (useIndexedDB && !hasIndexedDB()) {
      throw new Error('IndexedDB requested but not available')
    }

    if (useIndexedDB) {
      const row = await mapDisk.load(stateId)
      if (row) {
        row.data = parse(StateSchema, row.data)
        return row as MapRowValue
      }
      return null
    }

    // Otherwise fetch from cloud backend
    const response = await backendAxios.get(`/st1/maps/${stateId}`)
    const row: MapRowValue = response.data
    // validate row
    row.data = parse(StateSchema, row.data)
    return row as MapRowValue
  }
  return null
}

export default function createMapRowResource(
  stateId: Accessor<Nullable<StateOnlineId>>,
  disk: Accessor<StateMapDisk>
) {
  const resource = createResource(stateId, (id) => fetchMapById(id, disk()))
  return resource
}
